module.exports = __webpack_public_path__ + "img/arrow-right-light.dd4b02e0.svg";